import React from "react";

interface TermsModalProps {
  title: string;
  content: string;
  isOpen: boolean;
  onClose: () => void;
}

export function TermsModal({
  title,
  content,
  isOpen,
  onClose,
}: TermsModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] flex flex-col">
        {/* Header */}
        <div className="border-b px-4 md:px-6 py-3 md:py-4 flex justify-between items-center">
          <h2 className="text-base md:text-lg font-semibold text-gray-900">
            {title}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-2xl"
          >
            ×
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto px-4 md:px-6 py-3 md:py-4">
          <div className="text-xs md:text-sm text-gray-700 whitespace-pre-wrap leading-relaxed">
            {content}
          </div>
        </div>

        {/* Footer */}
        <div className="border-t px-4 md:px-6 py-3 md:py-4">
          <button
            onClick={onClose}
            className="w-full py-2 md:py-3 bg-orange-500 text-white text-sm md:text-base font-semibold rounded-lg hover:bg-orange-600 transition-colors"
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
}
